<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-gapoktan" lazy-validation>
        <h2 style="margin: 0% auto;"><b>Gapoktan Baru</b></h2>
        <h5>Gapoktan > Tambahkan Gapoktan</h5>
        <v-layout row wrap>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-users" label="Nama Kelompok Tani" name="namaKelompokTani" v-model="namaKelompokTani">
            </v-text-field>
            <small v-if="!isNamaKelompokTani" class="alert">Nama Kelompok Tani Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Jalan" name="jalan" v-model="jalan">
            </v-text-field>
            <small v-if="!isAlamatJalan" class="alert">Masukan Jalan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Desa" name="desa" v-model="desa">
            </v-text-field>
            <small v-if="!isAlamatDesa" class="alert">Masukan Desa</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kecamatan" name="kecamatan" v-model="kecamatan">
            </v-text-field>
            <small v-if="!isAlamatKecamatan" class="alert">Masukan Kecamatan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kabupaten" name="kabupaten" v-model="kabupaten">
            </v-text-field>
            <small v-if="!isAlamatKabupaten" class="alert">Masukan Kabupaten</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-map-marked-alt"
              v-model="selectProvinsi"
              :items="tipeProvinsi"
              label="Pilih Provinsi"
            ></v-select>
            <small v-if="!isAlamatProvinsi" class="alert">Pilih Provinsi</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="person" label="Nama Ketua Kelompok Tani" name="namaKetuaKelompokTani" v-model="namaKetuaKelompokTani">
            </v-text-field>
            <small v-if="!isNamaKetuaKelompokPetani" class="alert">Masukan Nama Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="phone" label="Kontak" name="kontakKetuaKelompokTani" v-model="kontakKetuaKelompokTani" type="number">
            </v-text-field>
            <small v-if="!isKontakKetuaKelompokPetani" class="alert">Masukan Kontak Minimal 10 Digit</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-balance-scale" label="Perkiraan Hasil Panen Satu Periode" name="waktuPanen" v-model="waktuPanen" suffix="Ton/Musim Tanam" type="number">
            </v-text-field>
            <small v-if="!isWaktuPanen" class="alert">Masukan Waktu Panen</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-apple-alt" label="Komoditas" name="komoditasPanen" v-model="komoditasPanen">
            </v-text-field>
            <small v-if="!isKomoditasPanen" class="alert">Masukan Komoditas Panen</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-money" label="Perkiraan Modal yang Digunakan" name="modalPanen" v-model="modalPanen" type="number" prefix="Rp. ">
            </v-text-field>
            <small v-if="!isModalPanen" class="alert">Masukan Modal Panen</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-hands-helping" label="Jenis Bantuan Pemerintah" name="jenisBantuanPemerintah" v-model="jenisBantuanPemerintah">
            </v-text-field>
            <small v-if="!isJenisBantuanPemerintah" class="alert">Masukan Jenis Bantuan Pemerintah</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-seedling" label="Sumber Benih" name="sumberBenih" v-model="sumberBenih">
            </v-text-field>
            <small v-if="!isSumberBenih" class="alert">Masukan Sumber Benih</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-crosshairs" label="Tujuan Instansi Pemasaran" name="tujuanInstansiPemasaran" v-model="tujuanInstansiPemasaran">
            </v-text-field>
            <small v-if="!isTujuanInstansiPemasaran" class="alert">Masukan Tujuan Instansi Pemasaran</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-seedling" label="Sumber Saprotan" name="sumberSaprotan" v-model="sumberSaprotan">
            </v-text-field>
            <small v-if="!isSumberSaprotan" class="alert">Masukan Sumber Saprotan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-balance-scale" label="Perkiraan Stock Hasil Pemanenan" name="stockHasilPanen" v-model="stockHasilPanen" suffix="Ton" type="number">
            </v-text-field>
            <small v-if="!isStockHasilPanen" class="alert">Masukan Stock Hasil Panen</small>
          </v-flex>
        </v-layout>        

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="back">Batal</v-btn>
          <v-btn color="primary" form="tambahkan-gapoktan" @click="getGapoktan" :disabled="!isComplete">Tambahkan Gapoktan</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import moment,{ locale } from 'moment'

export default {
  components: {
  },
  data: () => ({
    valid: true,
    date: null,
    modal: false ,

    namaKelompokTani: null,
    jalan: null,
    desa: null,
    kecamatan: null,
    kabupaten: null,
    selectProvinsi: null,
    tipeProvinsi: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  

    namaKetuaKelompokTani: null,
    kontakKetuaKelompokTani: null,
    waktuPanen: null,
    komoditasPanen: null,
    modalPanen: null,
    jenisBantuanPemerintah: null,
    sumberBenih: null,
    tujuanInstansiPemasaran: null,
    sumberSaprotan: null,
    stockHasilPanen: null,

    currentDateGapoktan: null,

    // Form Check
    reg: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  }),

  computed: {
    tipeDocs() {
      return [
        'Dokumen Usaha Dagang Perantara',
        this.kodePenjualan
      ]
    },

    // Form Check
    isComplete () {
      return (this.namaKelompokTani && this.namaKelompokTani.length >= 3) && (this.jalan) && (this.desa) && (this.kecamatan) && (this.kabupaten) && (this.selectProvinsi) && (this.namaKetuaKelompokTani && this.namaKetuaKelompokTani.length >= 3) && (this.waktuPanen && this.waktuPanen >= 0) && (this.komoditasPanen) && (this.modalPanen && this.modalPanen >= 0) && (this.jenisBantuanPemerintah) && (this.sumberBenih) && (this.tujuanInstansiPemasaran) && (this.sumberSaprotan) && (this.stockHasilPanen && this.stockHasilPanen >= 0);
    },
        
    isNamaKelompokTani () {
      return (this.namaKelompokTani && this.namaKelompokTani.length >= 3);
    },

    isAlamatJalan(){
      return (this.jalan)
    },

    isAlamatDesa(){
      return (this.desa)
    },

    isAlamatKecamatan(){
      return (this.kecamatan)
    },

    isAlamatKabupaten(){
      return (this.kabupaten)
    },

    isAlamatProvinsi(){
      return (this.selectProvinsi)
    },

    isNamaKetuaKelompokPetani(){
      return (this.namaKetuaKelompokTani && this.namaKetuaKelompokTani.length >= 3)
    },

    isKontakKetuaKelompokPetani(){
      return (this.kontakKetuaKelompokTani && this.kontakKetuaKelompokTani >= 0 && this.kontakKetuaKelompokTani.length >= 8)
    },

    isWaktuPanen(){
      return (this.waktuPanen && this.waktuPanen >= 0)
    },

    isKomoditasPanen(){
      return (this.komoditasPanen)
    },

    isModalPanen(){
      return (this.modalPanen && this.modalPanen >= 0)
    },

    isJenisBantuanPemerintah(){
      return (this.jenisBantuanPemerintah)
    },

    isSumberBenih(){
      return (this.sumberBenih)
    },

    isTujuanInstansiPemasaran(){
      return (this.tujuanInstansiPemasaran)
    },

    isSumberSaprotan(){
      return (this.sumberSaprotan)
    },

    isStockHasilPanen(){
      return (this.stockHasilPanen && this.stockHasilPanen >= 0)
    },

  },

  methods: {

    closeDialog () {
      this.$parent.isActive = false;
    },

    back(){
      window.getApp.$emit('APP_GAPOKTAN');
      // return '/pemerintah';
    },

    saveTemplate(){
      // window.getApp.$emit('APP_SIMPAN_TEMPLATE');
    },

    getGapoktan (){
      localStorage.gapoktanNamaKelompokTani = this.namaKelompokTani,
      localStorage.gapoktanDesa = this.desa,
      localStorage.gapoktanKecamatan = this.kecamatan,
      localStorage.gapoktanKabupaten = this.kabupaten,
      localStorage.gapoktanProvinsi = this.selectProvinsi,
      localStorage.gapoktanNamaKetuaKelompokTani = this.namaKetuaKelompokTani,
      localStorage.gapoktanKontakKetuaKelompokTani = this.kontakKetuaKelompokTani,
      localStorage.gapoktanWaktuPanen = this.waktuPanen,
      localStorage.gapoktanKomoditasPanen = this.komoditasPanen,
      localStorage.gapoktanmodalPanen = this.modalPanen,
      localStorage.gapoktanJenisBantuanPemerintah = this.jenisBantuanPemerintah,
      localStorage.gapoktanSumberBenih = this.sumberBenih,
      localStorage.gapoktanTujuanInstansiPemasaran = this.tujuanInstansiPemasaran,
      localStorage.gapoktanSumberSaprotan = this.sumberSaprotan,
      localStorage.gapoktanStockHasilPanen = this.stockHasilPanen,

      localStorage.gapoktanID = 'GAP-190400001'
      localStorage.currentDateGapoktan = moment().format('DD-MM-YYYY');

      window.getApp.$emit('APP_GAPOKTAN_SUCCESS');

    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
